<template>
  <div class="card">
    <h5 class="card-header">
      <span class="badge bg-info rounded-pill bx-pull-right font-size-12">
        Mes actual
      </span>
      Pagadas
    </h5>
    <div class="card-body">
      <div class="d-flex align-items-center">
        <div class="flex-shrink-0 me-3">
          <div class="avatar">
            <div class="avatar-title rounded bg-info bg-gradient">
              <eva-icon
                name="pie-chart-2"
                class="fill-white"
              ></eva-icon>
            </div>
          </div>
        </div>
        <div class="flex-grow-1">
          <p class="text-muted mb-1">
            Facturas pagadas en el mes
            <i class="mdi mdi-information"
              title="Incluye facturas que fueron pagadas anticipadamente y facturas pagadas en el mes actual"></i>
          </p>
          <h4 class="mb-0">{{ formatoMoneda(total) }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Componente de facturas pagadas del mes
 */
import accounting from 'accounting/accounting.js'
import FacturaSrv from '@/services/FacturaSrv.js'
export default {
  name: 'CmpFacturasPagadasMes',
  data() {
    return {
      total: 0,
      intervals: {
        actualizacion: null
      }
    }
  },
  computed: {
    monedaSistema:function(){
      return this.$store.state.todo.moneda_sistema
    }
  },
  created: function() {
    var self = this

    // Carga inicial del total de facturas pagadas
    self.refrescarTotal()
    // Carga periódica del total de las facturas pagadas
    self.intervals.actualizacion = setInterval(function() {
      self.refrescarTotal()
    }, 120000)
  },
  beforeUnmount: function() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    formatoMoneda: function(numero) {
      return accounting.formatMoney(numero, { symbol: this.monedaSistema.simbolo, miles: ",", decimal: "." })+' '+this.monedaSistema.codigo
    },
    refrescarTotal: function() {
      var self = this

      FacturaSrv.totalPagadasEnMes().then(response => {
        self.total = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo actualizar el total de facturas pagadas del mes'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
</style>